export type ReminderAnchor = 'before' | 'on' | 'after'

export type InvoiceReminderStep = {
  id: string
  days: number
  anchor: ReminderAnchor
  atTime: string
  emailTemplateGuid: string
}

export type InvoiceReminderSchedule = {
  enabled: boolean
  steps: InvoiceReminderStep[]
}

export type ReminderDayRange = {
  minDays: number
  maxDays: number
}

export type InvoiceReminderScheduleSettings = InvoiceReminderSchedule & ReminderDayRange & {
  available: boolean
}

export const emptyInvoiceReminderSchedule = (): InvoiceReminderSchedule => ({
  enabled: false,
  steps: []
})

export const toEditableSchedule = (settings: InvoiceReminderScheduleSettings): InvoiceReminderSchedule => ({
  enabled: settings.enabled,
  steps: settings.steps
})

export const hasUsableDayRange = (settings: InvoiceReminderScheduleSettings): boolean => {
  return Number.isInteger(settings.minDays)
    && Number.isInteger(settings.maxDays)
    && settings.maxDays >= settings.minDays
}
